import {CareGroup} from '@drl/shared/models/care-group.model';
import {User} from '@drl/core/auth/models/user.model';

export class CareGroupWithMembers {
  caregroup: CareGroup;
  members: User[];
}
